<template>
  <div class="mobile">
    <MobileTop class="mob-index" id="mob-index" />
    <div class="sizzle-1">
      <div class="top">
        <div class="kinostart" v-html="kinostart"></div>
        <div class="kinostart2" v-html="kinostart2"></div>
      </div>
      <MobileTrailer
        :youtube="$config.youtube"
        color="white"
        bordercolor="white"
      />
    </div>

    <!-- Dvd -->
    <div class="mob-dvd">
      <div class="cite">
        <img src="@/assets/images/cites/mobile2.png" alt="" />
      </div>
      <div class="packshot">
        <img src="@/assets/images/inhalt/packshot.png" alt="" />
      </div>
      <div class="buttons" :class="$mq">
        <a
          href="https://www.amazon.de/N%C3%B6-Anna-Br%C3%BCggemann/dp/B09Q8WM1DM/ref=sr_1_2?__mk_de_DE=%C3%85M%C3%85%C5%BD%C3%95%C3%91&crid=3BICSB7F0XID4&keywords=Dietrich+Br%C3%BCggemann&qid=1642500037&s=dvd&sprefix=dietrich+br%C3%BCggemann%2Cdvd%2C101&sr=1-2"
          target="_blank"
        >
          <img src="@/assets/images/inhalt/amazon.png" alt="Amazon" />
        </a>
        <a
          href="https://tv.apple.com/de/movie/no/umc.cmc.1apkv6r2wgbtv8jfezdc94rvj?itsct=tv_box_link&itscg=30200"
          target="_blank"
        >
          <img src="@/assets/images/inhalt/itunes.png" alt="Itunes" />
        </a>
      </div>
    </div>

    <!-- Inhalt -->
    <div id="mob-inhalt">
      <MobileExpandableCard
        class="mob-inhalt"
        image="card_inhalt.jpg"
        cardBg="var(--clr-red)"
        closeColor="black"
        btnTopAlign="left"
        btnTopColor="black"
        btnTopBg="transparent"
        btnBottomColor="black"
        btnBottomBg="transparent"
        cardBorderRadius="0px"
        imageAlign="center"
      >
        <!-- H1 Headline -->
        <template v-slot:headline> Inhalt </template>
        <!-- Teaser -->
        <template v-slot:teaser>
          <div>
            Dina <b>(Anna Brüggemann)</b> und Michael <b>(Alexander Khuon)</b>,
            er Arzt, sie Schauspielerin, sind eigentlich glücklich in ihrer
            Beziehung, bis Michael beginnt, laut über eine Trennung nachzudenken
            ...
          </div>
        </template>
        <!-- Hidden Maincontent -->
        <div>
          Dina <b>(Anna Brüggemann)</b> und Michael <b>(Alexander Khuon)</b>, er
          Arzt, sie Schauspielerin, sind eigentlich glücklich in ihrer
          Beziehung, bis Michael beginnt, laut über eine Trennung nachzudenken.
          Die Frage „Könnten wir nicht glücklicher sein als in dieser
          Konstellation?“ steht im Raum. Aber Dina sagt: „Nö.“<br /><br />
          <b
            >In fünfzehn Situationen und über sieben Jahre hinweg begleiten wir
            das Paar, wie es sich durchs Leben laviert und dabei versucht, die
            Liebe nicht aus den Augen zu verlieren. Wie es versucht, den eigenen
            Eltern gerecht zu werden, im Beruf nicht unterzugehen und selbst
            gute Eltern zu sein.</b
          >
        </div>
      </MobileExpandableCard>
    </div>
    <!-- Ende -->

    <div class="sizzle-2">
      <MobileTrailer
        :youtube="$config.youtube2"
        :number="2"
        sizzle="sizzle2mobile.mp4"
      />
    </div>

    <div class="mobile-cites">
      <img src="@/assets/images/cites/mobile.jpg" alt="" />
      <div class="text">
        <b>Dietrich Brüggemann:</b> „NÖ ist ein Film über die Liebe, über unsere
        Jagd nach ihr und unser Unvermögen, sie zu leben, wenn sie mal da ist.
        Ein Film über die verstreichende Zeit und über die Generation um die
        dreißig, die Vieles hat, Vieles versucht und oft still scheitert. Es ist
        aber auch ein Film über das, was das Kino besonders gut kann:
        Seelenzustände ausleuchten, die jenseits des Sichtbaren liegen, die aber
        nicht weniger real und ausschlaggebend für unseren Lebensweg sind.”
      </div>
    </div>

    <div class="sizzle-2">
      <MobileTrailer
        :youtube="$config.youtube3"
        :number="3"
        sizzle="sizzle3mobile.mp4"
      />
    </div>

    <!-- Team -->
    <div id="mob-team">
      <MobileExpandableCard
        class="mob-team"
        image="card_crew.jpg"
        cardBg="var(--clr-red)"
        closeColor="white"
        btnTopAlign="left"
        btnTopColor="black"
        btnTopBg="transparent"
        btnBottomColor="black"
        btnBottomBg="transparent"
        cardBorderRadius="0px"
        imageAlign="center"
      >
        <!-- H1 Headline -->
        <template v-slot:headline> Team </template>
        <!-- Teaser -->
        <template v-slot:teaser>
          <div>
            Die neue Kinokomödie von <b>Anna</b> und <b>Dietrich Brüggemann</b>.
            <b>Anna Brüggemann</b> fehlt auch nicht vor der Kamera und bildet
            mit
            <b
              >Alexander Khuon, Isolde Barth, Hanns Zischler, Petra
              Schmidt-Schaller</b
            >
            u.v.a. ein ausgezeichnetes Ensembe ...
          </div>
        </template>
        <!-- Hidden Maincontent -->
        <div>
          <table>
            <tr>
              <td>Michael</td>
              <td>Alexander Khuon</td>
            </tr>
            <tr>
              <td>Dina</td>
              <td>Anna Brüggemann</td>
            </tr>
            <tr>
              <td>Gertrud</td>
              <td>Isolde Barth</td>
            </tr>
            <tr>
              <td>Joachim</td>
              <td>Hanns Zischler</td>
            </tr>
            <tr>
              <td>Henriette</td>
              <td>Petra Schmidt-Schaller</td>
            </tr>
            <tr>
              <td>Hannah Garson</td>
              <td>Dulcie Smart</td>
            </tr>
            <tr>
              <td>Beata</td>
              <td>Nina Petri</td>
            </tr>
            <tr>
              <td>Matthias</td>
              <td>Andreas Döhler</td>
            </tr>
            <tr>
              <td>Patient im OP</td>
              <td>Rüdiger Vogler</td>
            </tr>
            <tr>
              <td>Arzt im Ultraschall</td>
              <td>Mark Waschke</td>
            </tr>
            <tr>
              <td>Zahnarzt</td>
              <td>Felix Goeser</td>
            </tr>
            <tr>
              <td style="padding-bottom: 30px"></td>
              <td></td>
            </tr>
            <tr>
              <td>Regie</td>
              <td>Dietrich Brüggemann</td>
            </tr>
            <tr>
              <td>Buch</td>
              <td>Anna Brüggemann,</td>
            </tr>
            <tr>
              <td></td>
              <td>Dietrich Brüggemann</td>
            </tr>
            <tr>
              <td>Produzent*innen</td>
              <td>Martin Heisler,</td>
            </tr>
            <tr>
              <td></td>
              <td>Gabriele Simon</td>
            </tr>
            <tr>
              <td>Redaktion</td>
              <td>Cooky Ziesche (Rbb),</td>
            </tr>
            <tr>
              <td></td>
              <td>Barbara Häbe (Arte)</td>
            </tr>
            <tr>
              <td>Bildgestaltung</td>
              <td>Alexander Sass</td>
            </tr>
            <tr>
              <td>Schnitt</td>
              <td>Vincent Assmann</td>
            </tr>
            <tr>
              <td>Szenenbild</td>
              <td>Cosima Vellenzer</td>
            </tr>
            <tr>
              <td>Kostümbild</td>
              <td>Juliane Maier</td>
            </tr>
            <tr>
              <td>Maskenbild</td>
              <td>Annett Schulze</td>
            </tr>
            <tr>
              <td>Tonmeister</td>
              <td>Tobias Rüther</td>
            </tr>
            <tr>
              <td>Sound Supervisor</td>
              <td>Martin Frühmorgen</td>
            </tr>
            <tr>
              <td>Mischtonmeister</td>
              <td>Gregor Bonse</td>
            </tr>
          </table>
        </div>
      </MobileExpandableCard>
    </div>
    <!-- Ende -->

    <div class="sizzle-2">
      <MobileTrailer
        :youtube="$config.youtube4"
        :number="4"
        sizzle="sizzle4mobile.mp4"
      />
    </div>

    <div id="mob-fotos" class="mob-fotos">
      <BaseCarousel
        :autoplay="false"
        :preview="true"
        :fade="true"
        :fullscreen="true"
        :dots="true"
      >
        <div class="source">
          <div
            v-for="value in this.$config.gallery.count"
            :key="value"
            class="carousel-cell"
          >
            <img
              :src="
                require(`@/assets/images/mobile/gallerie/` + value + `.jpg`)
              "
              alt
              class="pictures"
            />
          </div>
        </div>
      </BaseCarousel>
    </div>
  </div>
</template>

<script>
export default {
  inject: ['kinostart', 'kinostart2'],
}
</script>

<style lang="scss" scoped>
.mob-dvd {
  padding-top: 2em;
  .cite {
    padding-inline: 2em;
    max-width: 550px;
    margin-inline: auto;
    img {
      width: 100%;
    }
  }
  .packshot {
    padding-block: 2em;
    text-align: center;
  }
  .buttons {
    display: flex;
    flex-direction: row;
    justify-content: center;
    &.sm {
      flex-direction: column;
      align-items: center;
      a {
        margin-block: 10px;
      }
    }
    a {
      display: block;
      margin-inline: 10px;
    }
  }
}
table {
  tr {
    td:not(:first-child) {
      font-weight: 900;
      padding-left: 20px;
    }
  }
}
.sizzle-1 {
  border-top: 10px solid white;
  padding-block: 2em;
  background: transparent url('@/assets/images/inhalt/bg.jpg') top center
    no-repeat;
  background-size: cover;
  .top {
    padding-bottom: 1em;
    text-align: center;
    .kinostart {
      font-size: clamp(1.5rem, 6vw, 4rem);
      font-weight: 900;
      color: white;
      line-height: 1;
      text-transform: uppercase;
    }
    .kinostart2 {
      font-size: clamp(1rem, 4vw, 2rem);
      color: white;
      text-transform: uppercase;
    }
  }
}
.sizzle-2 {
  padding-block: 2em;
}
.mobile-cites {
  img {
    width: 100%;
  }
  .text {
    padding: 2em;
  }
}
</style>
